// Tree → the structure view. The zones are a projection: they read a query as
// blocks, context and one set of exclusions, and a shape that does not fit that
// picture used to fall back to read-only text. This mirrors the tree instead —
// every node, in place — so nothing ever has to be reshaped to stay editable.
import { Lexicon } from 'src/app/shared/models/ai-search.interface';
import { QbNode, QbNodeView } from './query-builder.types';
import { termsOf } from './query-builder.derive';

export function deriveNodeTree(
  input: QbNode | null | undefined,
  lexicon: Lexicon | null = null,
): QbNodeView {
  const read = (node: QbNode, path: number[]): QbNodeView => ({
    path,
    operator: node.operator ?? 'and',
    terms: termsOf(node.filters ?? [], path, lexicon),
    children: (node.groups ?? []).map((child, i) => read(child, [...path, i])),
  });
  return read(input ?? { operator: 'and', filters: [], groups: [] }, []);
}

/** How many terms sit at or below a node — what a collapsed node is worth. */
export function nodeTermCount(node: QbNodeView): number {
  return (
    node.terms.length +
    node.children.reduce((n, child) => n + nodeTermCount(child), 0)
  );
}
